import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { eRxComponent } from './erx.component';
import { DxPopupModule, DxSelectBoxModule } from 'devextreme-angular';
import { ConfigurationModule } from '../configuration/configuration.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import {MatBadgeModule} from '@angular/material/badge';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
  declarations: [
    eRxComponent,
  ],
    imports: [
        CommonModule,
        FormsModule, ReactiveFormsModule,

        NgxJsonViewerModule,
        ConfigurationModule,
        MatButtonModule, MatProgressSpinnerModule, MatIconModule,
        MatFormFieldModule, MatSelectModule,

        DxSelectBoxModule, DxPopupModule, TdoControlsModule, MatBadgeModule, MatTooltipModule
    ]
})
export class eRxModule { }
